import type { Optional } from '@festina-life/core'

import {
  ListLiteralContext,
  SetLiteralContext,
} from '../lexer/ANTLR/FPlusParser'

// Generic depth-first search (DFS) to find the first matching node
export const findCollectionNode = (
  node: unknown,
): Optional<ListLiteralContext | SetLiteralContext> => {
  if (!node) {
    return undefined
  }

  if (node instanceof ListLiteralContext || node instanceof SetLiteralContext) {
    return node
  }

  const withChildren = node as { children?: unknown[] }
  const children = withChildren.children ?? []
  for (const child of children) {
    const found = findCollectionNode(child)
    if (found) {
      return found
    }
  }
  return undefined
}
